"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

require("core-js/modules/es6.function.bind.js");

require("core-js/modules/es6.array.map.js");

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponents = require("@ucloud-fe/react-components");

var _style = require("./style");

var _RefreshMd = _interopRequireDefault(require("@ucloud/ucloud-icons/dist/uc-action/svgr/RefreshMd"));

var _Plus = _interopRequireDefault(require("@ucloud/ucloud-icons/dist/uc-action/svgr/Plus"));

var _this2 = void 0;

var SIZE = ["sm", "md", "lg"];
var Option = _reactComponents.Select.Option;
var optionsShape = {
  /**
   * item的唯一键
   */
  value: _propTypes["default"].any,

  /**
   * item的展示文本
   */
  label: _propTypes["default"].string,

  /**
   * 禁用
   */
  disabled: _propTypes["default"].bool
};
/**
 * ResourceSelect
 * @description 关联资源的选择-需要跳转新建的资源
 */

function ResourceSelect(props) {
  var _this = this;

  var defaultValue = props.defaultValue,
      value = props.value,
      options = props.options,
      size = props.size,
      _props$selectProps = props.selectProps,
      selectProps = _props$selectProps === void 0 ? {} : _props$selectProps,
      currentTip = props.currentTip,
      addNode = props.addNode,
      emptyContent = props.emptyContent,
      onChange = props.onChange,
      onCreate = props.onCreate,
      onReload = props.onReload;

  function handleChange(val) {
    onChange(val);
  }

  function handleReload() {
    onReload();
  } // 处理 Select 的 options 、value、size 和 defaultValue 值


  var selectObj = {
    defaultValue: defaultValue,
    size: size
  };

  if (value) {
    selectObj.value = value;
  }

  return !value && options.length === 0 && emptyContent ?
  /*#__PURE__*/
  //  处理空值的UI
  _react["default"].createElement(_style.StyledEmptyContent, {
    size: size
  }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Box, {
    container: true,
    spacing: "sm",
    alignItems: "center"
  }, emptyContent, /*#__PURE__*/_react["default"].createElement(_style.StyledIcon, {
    onClick: handleReload
  }, /*#__PURE__*/_react["default"].createElement(_RefreshMd["default"], null)))) : /*#__PURE__*/_react["default"].createElement(_reactComponents.Box, {
    container: true,
    spacing: "sm",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Box, {
    flex: "0 1 auto",
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Select, (0, _extends2["default"])({
    onChange: handleChange
  }, selectProps, selectObj, {
    extra: {
      autoHidePopup: true,
      content: /*#__PURE__*/_react["default"].createElement(_style.StyledCreateWrapper, {
        onClick: function () {
          (0, _newArrowCheck2["default"])(this, _this);
          return onCreate();
        }.bind(this)
      }, /*#__PURE__*/_react["default"].createElement(_Plus["default"], {
        className: "resource-select-icon"
      }), addNode)
    }
  }), options.map(function (option) {
    (0, _newArrowCheck2["default"])(this, _this);
    var value = option.value,
        label = option.label,
        _option$disabled = option.disabled,
        disabled = _option$disabled === void 0 ? false : _option$disabled;
    return /*#__PURE__*/_react["default"].createElement(Option, {
      key: value,
      value: value,
      disabled: disabled
    }, label !== undefined ? label : value);
  }.bind(this)))), /*#__PURE__*/_react["default"].createElement(_reactComponents.Box, {
    container: true,
    spacing: "sm",
    alignItems: "center",
    flex: "0 0 auto"
  }, currentTip && /*#__PURE__*/_react["default"].createElement("span", null, currentTip), /*#__PURE__*/_react["default"].createElement(_style.StyledIcon, {
    onClick: handleReload
  }, /*#__PURE__*/_react["default"].createElement(_RefreshMd["default"], null))));
}

ResourceSelect.propTypes = {
  /**
   * 选项
   */
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape(optionsShape)).isRequired,

  /**
   * 默认值，不受控
   */
  defaultValue: _propTypes["default"].any,

  /**
   * 当前值，受控
   */
  value: _propTypes["default"].any,

  /**
   * 尺寸大小, 默认为 ‘md’
   */
  size: _propTypes["default"].oneOf(SIZE),

  /**
   * 选择框 Select props（除 value、defaultValue、size 以外的）
   */
  selectProps: _propTypes["default"].object,

  /**
   * 针对选中项的说明
   */
  currentTip: _propTypes["default"].node,

  /**
   * 新增文案
   */
  addNode: _propTypes["default"].node.isRequired,

  /**
   * options 为空并且无选项时的显示样式（注意与 Select 中的 emptyContent 的区别 ）
   */
  emptyContent: _propTypes["default"].node,

  /**
   * 修改时的回调
   */
  onChange: _propTypes["default"].func,

  /**
   * 点击 “新增” 时的回调
   */
  onCreate: _propTypes["default"].func,

  /**
   * 点击 “刷新” 的回调
   */
  onReload: _propTypes["default"].func
};
ResourceSelect.defaultProps = {
  size: SIZE[1],
  onChange: function onChange() {
    (0, _newArrowCheck2["default"])(this, _this2);
  }.bind(void 0),
  onCreate: function onCreate() {
    (0, _newArrowCheck2["default"])(this, _this2);
  }.bind(void 0),
  onReload: function onReload() {
    (0, _newArrowCheck2["default"])(this, _this2);
  }.bind(void 0)
};
var _default = ResourceSelect;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/ResourceSelect/ResourceSelect.js
// module id = 2152
// module chunks = 6 7 17 18